import { useRef } from 'react'
import { useCalculateSize } from '../../../../common/hooks/useCalculateSize'
import { Table } from '../../../../common/table'
import WrapPagination from './WrapPagination'
import { getSchema } from './helper'

const ListCompany = ({
  ids,
  selectDataFromRedux,
  selectPaginationInfo,
  setPage,
  setPageSize,
}) => {
  const tableRef = useRef()
  const { height } = useCalculateSize(tableRef)

  return (
    <div
      ref={tableRef}
      className="flex1 minH0 positionRelative"
      style={{ marginTop: 4 }}
    >
      <div className="positionAbsolute wh100" style={{ left: 0, top: 0 }}>
        <Table
          ids={ids}
          isDisplayScroll={true}
          getDataFromRedux={selectDataFromRedux}
          isNoDataWithHead={true}
          schema={getSchema()}
          renderPagination={() => (
            <WrapPagination
              selectPaginationInfo={selectPaginationInfo}
              setPage={setPage}
              setPageSize={setPageSize}
            />
          )}
          keyReCalculateSize={height}
        />
      </div>
    </div>
  )
}

export default ListCompany
